import ServiceComponent from './Component';

const Service = () => {
  return <ServiceComponent />
}
export default Service;
